import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";
import { truncateString } from "utils/UtilityFuncs";

export default function ShipAddressList({
  shipment,
  products,
  addressForm,
  setAddressForm,
}) {
  const dispatch = useDispatch();
  /*   All States
   ********************************************* */
  const [showAddressListModal, setShowAddressListModal] = useState(null);
  const [addressList, setAddressList] = useState(null);
  const [loading, setLoading] = useState(false);

  /*   All Functions
   ********************************************* */
  const loadingOn = () => {
    setLoading(true);
  };
  const loadingOff = () => {
    setLoading(false);
  };
  const getUniqueWoIdList = (shipmentProductList) => {
    let woIdList = shipmentProductList?.map((prod) => prod.woId);
    let uniqueWoIdList = [...new Set(woIdList)];
    return uniqueWoIdList;
  };

  const getAddressList = async (shipmentProductList) => {
    try {
      if (!shipmentProductList || shipmentProductList.length === 0) {
        return;
      }
      const woList = getUniqueWoIdList(shipmentProductList);
      loadingOn();

      const { data } = await API.post(
        "/sales/shipment/product/wo-ship-address",
        {
          woList,
        },
        { headers: authHeader() }
      );

      if (data?.success) {
        let _addressList = data?.data;

        // check if _addressList shippingAddress is of type string then parse it to json
        // handle multiple levels of JSON.stringify
        _addressList = _addressList?.map((addr) => {
          if (
            addr?.shippingAddress &&
            typeof addr?.shippingAddress === "string"
          ) {
            try {
              let parsedAddress = addr.shippingAddress;
              // Keep parsing until we get an object or can't parse anymore
              while (typeof parsedAddress === "string") {
                const temp = JSON.parse(parsedAddress);
                if (typeof temp === "string") {
                  parsedAddress = temp;
                } else {
                  parsedAddress = temp;
                  break;
                }
              }
              addr.shippingAddress = parsedAddress;
            } catch (err) {
              console.error("Error parsing shippingAddress:", err);
            }
          }
          return addr;
        });

        // flat map to have woId and shippingAddress
        _addressList = _addressList?.flatMap((addr) => {
          return {
            woId: addr.woId,
            ...addr.shippingAddress,
          };
        });

        setAddressList(_addressList);
      } else {
        throw new Error(data?.message);
      }
      loadingOff();
    } catch (err) {
      loadingOff();
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  const selectAddress = (addr) => {
    setAddressForm({
      addressContact: addr.attentionTo,
      addressCompany: addr.company,
      addressLine1: addr.addressLine1,
      addressLine2: addr.addressLine2,
      city: addr.city,
      state: addr.state,
      zip: addr.zip,
      country: addr.country,
    });
    setShowAddressListModal(false);
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    let timeout = setTimeout(() => {
      if (products && showAddressListModal) {
        getAddressList(products);
      }
    }, 50);
    return () => {
      setAddressList(null);
      clearTimeout(timeout);
    };
  }, [products, shipment, showAddressListModal]);

  return (
    <div className="relative">
      {loading && <Spinner />}
      <button
        className="btn btn-sm btn-success"
        onClick={() => setShowAddressListModal(true)}
      >
        Ship Address List
      </button>

      <Modal
        size="xl"
        show={showAddressListModal}
        onHide={() => setShowAddressListModal(false)}
      >
        <Modal.Header className="py-1" closeButton>
          <Modal.Title>Shipping Address List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Responsive bootstrap Table */}
          <div className="table-responsive">
            {products && products?.length > 0 ? (
              <table className="table table-sm table-bordered table-striped table-hover">
                <thead>
                  <tr>
                    <th>W-ID</th>
                    <th>Company</th>
                    <th>Address Type</th>
                    <th>Contact</th>
                    <th>Address Line 1</th>
                    <th>City/State/Zip</th>
                    <th>Country</th>

                    <th className="text-end">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {addressList?.map((addr) => (
                    <tr key={addr.woId}>
                      <td className="py-1 align-middle">W-{addr?.woId}</td>
                      <td className="py-1 align-middle">
                        {truncateString(addr?.addressCompany, 15)}
                      </td>
                      <td className="py-1 align-middle">
                        {truncateString(addr?.addressType, 15)}
                      </td>
                      <td className="py-1 align-middle">
                        {truncateString(addr?.attentionTo, 15)}
                      </td>

                      <td className="py-1 align-middle">
                        {truncateString(addr?.addressLine1, 15)}
                      </td>

                      <td className="py-1 align-middle small">
                        {addr?.city ? addr.city + ", " : ""}
                        {addr?.state ? addr.state + " " : ""}
                        {addr?.zip ? addr.zip : ""}
                      </td>
                      <td className="py-1 align-middle">{addr.country}</td>
                      <td className="py-1 align-middle text-end">
                        <button
                          onClick={() => selectAddress(addr)}
                          className="btn btn-sm btn-success"
                        >
                          Select
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No products added to shipment yet to fetch address list.</p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="py-1">
          <button
            className="btn btn-secondary btn-sm"
            onClick={() => setShowAddressListModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
